import { useReceivedInvoiceSearchQuery } from '@/features/invoices/components/List/Table/hook';
import { useReceivedInvoicesFormInitial } from '@/features/invoices/components/List/hooks';
import {
  List,
  ReceivedInvoiceSearch,
} from '@features/invoices/components/List';
import classNames from 'classnames/bind';
import { FC, memo, useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export const TemplateInvoiceList: FC = memo(() => {
  const defaultValues = useReceivedInvoicesFormInitial();
  const [isTriggeredSearch, setIsTriggeredSearch] = useState(false);
  const [isPolling, setIsPolling] = useState(false);

  const { searchQuery, handleSearch } =
    useReceivedInvoiceSearchQuery(defaultValues);

  return (
    <div className={cx(styles['container'])}>
      <ReceivedInvoiceSearch
        defaultValues={defaultValues}
        onSearch={handleSearch}
        setIsTriggeredSearch={setIsTriggeredSearch}
        isPolling={isPolling}
      />
      <List
        searchQuery={searchQuery}
        onSearch={handleSearch}
        isTriggeredSearch={isTriggeredSearch}
        setIsTriggeredSearch={setIsTriggeredSearch}
        setIsPolling={setIsPolling}
      />
    </div>
  );
});

TemplateInvoiceList.displayName = 'TemplateInvoiceList';
